import { render } from "./TodoListItem.vue?vue&type=template&id=0a2f34c4&scoped=true"
import script from "./TodoListItem.vue?vue&type=script&lang=js"
export * from "./TodoListItem.vue?vue&type=script&lang=js"

import "./TodoListItem.vue?vue&type=style&index=0&id=0a2f34c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2f34c4"]])

export default __exports__